module.exports = __webpack_public_path__ + "static/img/home-top2.f5f3681.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-top2.png
// module id = OUrg
// module chunks = 21